import axios from 'axios';
import {
    MDBAlert,
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBInput, MDBTooltip
} from "mdb-react-ui-kit";

import PropTypes from 'prop-types';
import React, { useEffect, useState,useContext } from "react";
import { fetchMainPageData } from '../utils/Common';
import { NavbarContext } from '../context/NavProvider';
const PhoneForm = ({ showPhoneModal, setShowPhoneModal, phonesId, setPhones, phones = [], setIsPhoneFormSubmitted, phoneToUpdate, updatePhoneId }) => {

    const baseUrl = process.env.REACT_APP_INVENTORY_URL;
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertColor, setAlertColor] = useState('');
    const [isValid, setIsValid] = useState(false);
    const {setIsPricing,pageData,setPageData} = useContext(NavbarContext);

    useEffect(() => {
      if (!pageData) {
        fetchMainPageData(setPageData,setIsPricing,pageData);
        
      }
    }, []);

    const initialFormValues = phoneToUpdate ?  [phoneToUpdate] : [{ type: '', number: '' }];
    const [localPhones, setLocalPhones] = useState(initialFormValues);

    useEffect(() => {
        if (phoneToUpdate) {
            setLocalPhones([phoneToUpdate]);
        } else {
            setLocalPhones([{
                type: '',
                number: '',
            }]);
        }
    }, [phoneToUpdate]);

    const addPhone = () => {
        setLocalPhones(prev => [...prev, {
            type: '',
            number: '',
        }]);
    };

    const removePhone = (indexToRemove) => {
        setLocalPhones(prevPhones =>
            prevPhones.filter((_, index) => index !== indexToRemove)
        );
    };

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const list = [...localPhones];
        list[index][name] = value;
        setLocalPhones(list);
        setIsValid(e.target.validity.valid);
    };

    const hasDuplicatePhoneType = (phones) => {
        const types = phones?.map(phone => phone.type);
        return new Set(types).size !== types.length;
    };

    const handleFormSubmit = (event) => {
        event.preventDefault();
        if (hasDuplicatePhoneType(localPhones)) {
            setAlertMessage('Duplicate phone types are not allowed');
            setAlertColor('danger');
            setShowAlert(true);
            setTimeout(() => setShowAlert(false), 5000);
            return;
        }
        const axiosConfig = {
            method: phonesId ? 'put' : 'post',
            url: phonesId ? `${baseUrl}/phones/${phonesId}` : `${baseUrl}/phones`,
            data: localPhones
        };

        axios(axiosConfig)
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    showPhoneModal ? setPhones(response.data) : setPhones(response.data.phoneSet);
                    !showPhoneModal && updatePhoneId(response.data.id);
                    setAlertMessage('Phones have been saved');
                    setAlertColor('success');
                    setShowAlert(true);
                    setTimeout(() => {
                        setShowAlert(false);
                        showPhoneModal && setShowPhoneModal(false);
                        !showPhoneModal && setIsPhoneFormSubmitted(true);
                        setLocalPhones([{
                            type: '',
                            number: '',
                        }]);
                    }, 1000);
                }
            })
            .catch(error => {
                console.error(error);
                setAlertMessage('An error occurred while saving the phones');
                setAlertColor('danger');
                setShowAlert(true);
                setTimeout(() => setShowAlert(false), 1000);
            });
    };

    const isFormValid = () => {
        return localPhones.every(phone =>
            Object.values(phone).every(field => typeof field === 'string' && field.trim() !== '')
        );
    };

    return (
        <section className="grainy-gradient-intro " style={{ marginBottom: '20px' }} >
            <h5 className="display-8 fw-bold text-uppercase text-black mb-0 text-center" style={{ letterSpacing: '15px' }}> Phone </h5>
            <hr className="hr" />
            <MDBCard>
                <MDBCardBody className="text-center pt-4">
                    <form onSubmit={handleFormSubmit} onClick={(e) => {  e.stopPropagation(); }}>

                        {localPhones.map((phone, index) => (
                            <div key={index}>
                                {localPhones.length > 1 && (
                                    <MDBBtn className='me-2' type="button" onClick={() => removePhone(index)}>
                                        Remove Phone
                                    </MDBBtn>
                                )}
                                <MDBInput className="mb-4" label="Type *" name="type" value={phone.type} onChange={(e) => handleInputChange(e, index)} required />

                                <MDBTooltip
                                    wrapperProps={{ color: 'light' }}
                                    title={
                                        <>
                                            <em>Format: </em> <b>+1 123 456 7890</b>
                                        </>
                                    }
                                    onClick={(e) => e.stopPropagation()} onChange={(e) => {

                                        e.stopPropagation();
                                    }}
                                >
                                    <MDBInput
                                        className="mb-4"
                                        label="Number *"
                                        name="number"
                                        value={phone.number}
                                        type='tel'
                                        pattern="^\+\d{1} \d{3} \d{3} \d{4}$"
                                        onChange={(e) => {
                                            handleInputChange(e, index);
                                            e.stopPropagation();
                                        }}
                                        required
                                        onClick={(e) => {
                                            console.log("Input clicked");
                                            e.stopPropagation();
                                        }}
                                    />


                                </MDBTooltip>


                                {index < phones.length - 1 && <hr className="hr" />}
                            </div>
                        ))}
                        <div className="d-grid gap-2 d-md-block " >
                            <MDBBtn className='me-2' type="button" onClick={addPhone}>
                                Add Phone
                            </MDBBtn>
                            <MDBBtn type="submit" disabled={!isFormValid()}>
                                Save
                            </MDBBtn>
                            {showPhoneModal && <MDBBtn className='mx-2' color='danger' onClick={() => setShowPhoneModal(false)}>Close</MDBBtn>}
                        </div>
                    </form>
                </MDBCardBody>

                <MDBAlert open={showAlert}
                    color={alertColor}
                    autohide
                    width={800}
                    position="top-right"
                    offset={50}
                    delay={2000}
                    appendToBody
                >
                    {alertMessage}
                </MDBAlert>
            </MDBCard>
        </section>
    );
};

PhoneForm.propTypes = {

    setShowPhoneModal: PropTypes.func,
    showPhoneModal: PropTypes.bool,
    phonesId: PropTypes.string,
    setPhones: PropTypes.func,
    phones: PropTypes.arrayOf(PropTypes.object),
    setIsPhoneFormSubmitted: PropTypes.func,
    phoneToUpdate: PropTypes.object,
    updatePhoneId: PropTypes.func,
}

export default PhoneForm;
